import React, { useEffect, useState } from 'react';
import { getRecordById } from '../../../localDB';
import TauriImage from '../../TauriImage/TauriImage';
import OpalAnnouncementList from './OpalAnnouncementList/OpalAnnouncementList';

const OpalAnnouncementVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const [topAnnouncement, setTopAnnouncement] = useState(null);
    const [showAnnouncement, setShowAnnouncement] = useState(false);

    useEffect(() => {
        if (Array.isArray(chartData) && chartData.length > 0) {
            const highestPriority = Math.min(...chartData.map(item => item.Priority ?? Infinity));

            const highestPriorityItems = chartData.filter(item => item.Priority === highestPriority);

            highestPriorityItems.sort((a, b) => new Date(b.Date) - new Date(a.Date));

            if (highestPriorityItems.length > 0) {
                // setTopAnnouncement(highestPriorityItems[0]);
                setTopAnnouncement(null);
            }
        }
    }, [chartData]);

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        }); // e.g., April 1, 2025
    };

    // if (!topAnnouncement) return null;

    return (
        <div className='chart-content'>
            <div className='announcement-date'
                style={{ fontFamily: 'Lato-semibold', marginTop: 'auto' }}>
                {topAnnouncement && formatDate(topAnnouncement?.Date)}
            </div>
            <div className='announcement-info d-flex align-items-center justify-content-between'>
                {topAnnouncement ? <>
                    <span>{topAnnouncement?.Message}</span>
                    <div style={{ cursor: "pointer" }}><TauriImage
                        onClick={() => setShowAnnouncement(true)}
                        localImage={"/Images/arrow-right.svg"}
                        alt='icon' />
                    </div>
                </> : <><span>No recent announcement!</span></>
                }
            </div>
            <OpalAnnouncementList
                show={showAnnouncement}
                onHide={() => setShowAnnouncement(false)}
                // items={chartData}
                items={[]}
            />
        </div>
    );
};

export default OpalAnnouncementVisual;
